<template class="">
  <div class="row pad-to-15"> 
    <div class="col-md-12">
      <div class="pull-left">
        <router-link to="/feedback" class="btn btn-info"><i class="ti-arrow-left"></i> {{$t('general.back')}}</router-link>
      </div>
    </div>
    <div class="col-lg-10 col-md-12 pad-to-15">
      <div class="card feedback-card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-7 feedback-sides">
              <p class="feedback-top">
                <span class="label label-empty" :class="'label-' + feedbackTypeClass(message.type)" >{{$t('feedbackTypes.' + message.type)}}</span>
                 <span class="time">{{formatDateTime(message.created_at)}}</span>
              </p>
              <h6>{{message.creater.name}} </h6>
              <div>{{message.text}}</div>
            </div>
            <div class="col-md-5 feedback-sides">
              <h6 class="mar-to-0"> <img class="icon-card-header" src="/static/img/icons/user-sm.png">  {{$t('customers.title')}}</h6>
                   <hr class="sm">
              <div class="row pad-bt-10">
                <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><b>{{$t('customers.name')}}</b></div>
                <div class="col-lg-8 col-sm-7 col-xs-12">{{message.creater.firstname}} {{message.creater.lastname}}</div>
              </div>
              <div class="row pad-bt-10">
                <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><b>{{$t('customers.email')}}</b></div>
                <div class="col-lg-8 col-sm-7 col-xs-12">{{message.creater.email ? message.creater.email : '-'}}</div>
              </div>
              <div class="row pad-bt-10">
                <div class="col-lg-4 col-sm-5 col-xs-12 details-label"><b>{{$t('customers.phone')}}</b></div>
                <div class="col-lg-8 col-sm-7 col-xs-12">{{message.creater.phone ? message.creater.phone : '-'}}</div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import TimeLine from './../../Dashboard/Stats/TimeLine.vue'
  import TimeLineItem from './../../Dashboard/Stats/TimeLineItem.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      TimeLine,
      TimeLineItem
    },
    data () {
      return {
        message: {},
        loading: true
      }
    },
    created: function () {
      this.$nextTick(function () { this.loading = true })

      if (this.$route.params.id) {
        var id = this.$route.params.id
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/feedback/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            self.message = response.data[0]
            self.$nextTick(function () { self.loading = false })
            if (response.data[0].seen === 0) {
              self.apiRequest('/feedback/' + id, 'DELETE', data, function (response) {
                console.warn('seen')
              })
            }
          }
        })
      }
    },
    methods: {
    }
  }
</script>
<style>
.table tbody tr:first-of-type > td{
  border-top: 0px solid #fff; 
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Feedback/FeedbackView.vue